import { CORE_DEFAULT_VALUES } from '../../core/config/defaultValues/defaultValues';
import { APP_DEFAULT_VALUES } from '../../app/config/defaultValues/defaultValues';

export const DEFAULT_VALUES = {
  ...CORE_DEFAULT_VALUES,
  ...APP_DEFAULT_VALUES,
  defaultCountryState: null,
  // UK storefront - customers pay in GBP; per-order currency (EUR-paid
  // orders) overrides this where the payment carries its own currency.
  currencyState: '£',
  isInternationalCountryName: false,
  isDateSelectPreferred: false,
  defaultCardStyle: {
    transition: 'box-shadow 300ms cubic-bezier(0.4, 0, 0.2, 1) 0ms',
    boxShadow:
      'rgba(145, 158, 171, 0.2) 0 0 2px 0, rgba(145, 158, 171, 0.12) 0 12px 24px -4px',
  },
  defaultCountry: 'GB',
  defaultCompanyValidationPermissions: [],
  defaultCompanyDetailsEnabledPermissions: [],
  defaultCompanyAdminsListEnabledPermissions: [],
  defaultCompanyPermissionsManagemetPermissions: [],
};
